import request from '@/utils/request'

// 线索列表（POST body，后端 param() 兼容）
export function leadList(data) {
  return request.post('/lead/index', data)
}

// 线索详情
export function leadDetail(id) {
  return request.post('/lead/detail', { id })
}

// 录入线索（仅推广人员）
export function leadAdd(data) {
  return request.post('/lead/add', data)
}

// 标记已添加（分配的销售本人）
export function leadMarkAdded(id) {
  return request.post('/lead/markAdded', { id })
}

// 切换是否已添加微信（仅管理员）
export function leadToggleAdded(id, isAdded) {
  return request.post('/lead/toggleAdded', { id, is_added: isAdded ? 1 : 0 })
}

// 切换是否成交（仅管理员）
export function leadToggleDeal(id, isDeal) {
  return request.post('/lead/toggleDeal', { id, is_deal: isDeal ? 1 : 0 })
}

// 转移给其他销售（仅管理员）
export function leadTransfer(id, staffId) {
  return request.post('/lead/transfer', { id, staff_id: staffId })
}

// 删除线索（仅管理员）
export function leadDelete(id) {
  return request.post('/lead/delete', { id })
}
